import React from 'react';
import { Container } from 'react-bootstrap';
import PublicNavigation from '../components/Navigation/PublicNavigation';

const sectionStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  padding: '24px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
  marginBottom: '20px',
};

const PrivacyPolicy = () => {
  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <PublicNavigation />

      <div style={{ paddingTop: '92px', paddingBottom: '40px' }}>
        <Container style={{ maxWidth: '960px' }}>
          <div style={sectionStyle}>
            <h1 style={{ marginBottom: '8px' }}>Política de Privacidad</h1>
            <p className="text-muted mb-0">
              La presente Política de Privacidad describe la forma en que Kinexion recopila, usa,
              almacena, protege y, en su caso, elimina la información relacionada con el uso de la
              plataforma y de las integraciones de WhatsApp para empresas de transporte.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>1. Información que recopilamos</h3>
            <p>
              Kinexion recopila la información estrictamente necesaria para prestar los servicios
              contratados y habilitar las funciones de comunicación empresarial. Dicha información
              puede incluir:
            </p>
            <ul>
              <li>Números telefónicos utilizados para comunicaciones operativas.</li>
              <li>Mensajes, plantillas, registros de envío y metadatos relacionados con actualizaciones de viaje y alertas operativas.</li>
              <li>Información empresarial obtenida durante el proceso de embedded signup, configuración inicial y administración continua de la cuenta.</li>
            </ul>
          </div>

          <div style={sectionStyle}>
            <h3>2. Finalidades del tratamiento</h3>
            <p>
              La información recopilada se utiliza para permitir que cada empresa cuente con un medio
              de coordinación interna y operativa, incluyendo el envío de actualizaciones a clientes,
              choferes y equipos relacionados con la ejecución de viajes, así como para administrar la
              configuración y operación general de la plataforma.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>3. Almacenamiento y protección de la información</h3>
            <p>
              La información se almacena en las bases de datos de Kinexion y se mantiene segregada por
              empresa. En condiciones normales de operación, cada empresa solo puede acceder a la
              información que le corresponde dentro de su propio entorno de trabajo. Kinexion adopta
              medidas razonables de control y protección acordes con la naturaleza de la información y
              con la arquitectura de la plataforma.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>4. Eliminación y supresión de datos</h3>
            <p>
              Cuando una empresa deja de utilizar la plataforma, sus datos pueden ser eliminados como
              parte del proceso de offboarding. Adicionalmente, la empresa puede solicitar la eliminación
              específica de su información mediante una solicitud enviada a{' '}
              <a href="mailto:contacto@kinexion.io">contacto@kinexion.io</a>. Kinexion evaluará y atenderá
              dichas solicitudes conforme a sus obligaciones legales y contractuales aplicables.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>5. Cumplimiento normativo</h3>
            <p>
              Kinexion trata la información de conformidad con la legislación aplicable en México,
              incluyendo la Ley Federal de Protección de Datos Personales en Posesión de los Particulares
              (LFPDPPP), en la medida en que resulte aplicable al uso de la plataforma y a la relación
              comercial con cada empresa cliente.
            </p>
          </div>

          <div style={sectionStyle}>
            <h3>6. Relación con Meta y WhatsApp</h3>
            <p>
              Determinadas funciones de comunicación pueden operar sobre servicios prestados por Meta y
              WhatsApp. En consecuencia, el uso de dichas funciones también puede estar sujeto a los
              términos, políticas, lineamientos y requisitos establecidos por las plataformas de Meta y
              WhatsApp, incluyendo sus reglas para mensajería empresarial.
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
